import { render, staticRenderFns } from "./add_contact_owner_on_milt_modal.vue?vue&type=template&id=aa46d51a&scoped=true"
import script from "./add_contact_owner_on_milt_modal.vue?vue&type=script&lang=js"
export * from "./add_contact_owner_on_milt_modal.vue?vue&type=script&lang=js"
import style0 from "./add_contact_owner_on_milt_modal.vue?vue&type=style&index=0&id=aa46d51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa46d51a",
  null
  
)

export default component.exports